<template>
    <div class="cta-image-area cta-image-bg_02">
        <div class="container">
            <div class="row">
                <div class="col-lg-12">
                    <div class="cta-image">
                        <div class="row align-items-center">
                            <div class="col-lg-6 order-2 order-lg-1">
                                <div class="cta-image__content">
                                    <h4 class="cta-image__title text-white mb-20 wow move-up">{{ $t('uygulamamizisimdiucretsizdeneyin') }}</h4>
                                    <div class="cta-image__text text-white mb-20 wow move-up">{{ $t('isinizebuyumeicineniyiyardimisunun') }}</div>
                                    <ul class="footer-widget__list">
                                    <router-link to="/contacts" class="btn btn--green wow move-up">
                                        <span class="btn-icon  ml-0 mr-2"><i class="fa fa-arrow-alt-to-bottom"></i></span> {{ $t('ucretsizdene') }}
                                    </router-link>
                                    <span>
                                <li class="btn btn--green">
                                <a href="https://apps.apple.com/tr/app/karpin-mobil/id6443685147?l=tr" target="_blank" ><i class="fab fa-apple social-link-icon"></i> App Store {{$t('indir')}}</a>
                                </li>
                                </span>
                                <span>
                                <li class="btn btn--green">
                                <a href="https://play.google.com/store/apps/details?id=com.karpin.mobile" target="_blank"><i class="fab fa-android social-link-icon"></i> GooglePlay {{$t('indir')}}</a>
                                </li>
                                </span>
                                </ul>
                                </div>
                            </div>
                            <div class="col-lg-6 order-1 order-lg-2">
                                <div class="cta-image_two section-space--mt_60 wow move-up">
                                    <img src="../assets/img/banners/macbook-02.png" class="img-fluid" alt="Karpin-Erp-Mobil" loading="lazy">
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    export default {
        name: 'CtaThree',
    }
</script>